import React from 'react';
import { Badge } from 'react-bootstrap';

const TaskStatusIcon = ({ status, categoryTitle }) => {
  switch (status) {
    case 'not_started':
      return <Badge pill bg="danger"><span className="material-icons text-white md-18">close</span></Badge>;
    case 'in_progress':
      return <Badge pill bg="warning"><span className="material-icons text-white md-18">format_align_center</span></Badge>;
    case 'completed':
      return <Badge pill bg="success"><span className="material-icons text-white md-18">done</span></Badge>;
    default:
      return null;
  }
};

export default TaskStatusIcon;
